import * as mutations from './mutation-types'

export const slack_set_is_signed_in = (store, isSignedIn) => {
    store.commit(mutations.SLACK_SET_IS_SIGNED_IN, isSignedIn)
}